import { createContentNode, createContentNodeWithSelection, } from './ContentNode/ContentNode.utils';
import { runtimeOperationTypes } from './StateOperations';
export const ManualContentHelpers = {
    createContentNode: (config, data) => {
        return createContentNode(config, data);
    },
    createContentNodeWithSelection: (config, data) => {
        return createContentNodeWithSelection(config, data);
    },
    createReference: (selector) => {
        return {
            kind: 'REFERENCE',
            value: selector,
        };
    },
    createQueryDataReference: (queryId, selector = []) => {
        return {
            kind: runtimeOperationTypes.REFERENCE.kind,
            value: ['query', queryId, ...selector],
        };
    },
    createThisContentNodeReference: (selector = []) => {
        return {
            kind: runtimeOperationTypes.THIS_CONTENT_NODE_REFERENCE.kind,
            value: selector,
        };
    },
    createFallback: (value) => {
        return {
            kind: runtimeOperationTypes.FALLBACK.kind,
            value,
        };
    },
    createFilteredListReference: (list, condition) => {
        return {
            kind: runtimeOperationTypes.FILTER_LIST.kind,
            value: [list, condition],
        };
    },
    createFilteredListContentNodeReference: (list, condition) => {
        return {
            kind: runtimeOperationTypes.FILTER_LIST_CONTENT_NODE.kind,
            value: [list, condition],
        };
    },
    createStringBuilder: (value) => {
        return {
            kind: runtimeOperationTypes.STRING_BUILDER.kind,
            value,
        };
    },
    createListToString: (value) => {
        return {
            kind: runtimeOperationTypes.LIST_TO_STRING.kind,
            value,
        };
    },
    createDataType: (dataType) => {
        return {
            kind: 'DATA_TYPE',
            value: dataType,
        };
    },
    createContentNodeReference: (queryId, selector = []) => {
        return {
            kind: runtimeOperationTypes.CONTENT_NODE_REFERENCE.kind,
            value: [queryId, ...selector],
        };
    },
    setState: (config, state) => {
        return {
            kind: runtimeOperationTypes.SET_STATE.kind,
            value: [config, state],
        };
    },
    createNullContentNodeReferece: () => {
        return {
            kind: runtimeOperationTypes.NULL_CONTENT_NODE_REFERENCE.kind,
            value: [],
        };
    },
    createGenerateUrlStorage: (value) => {
        return {
            kind: runtimeOperationTypes.GENERATE_URL_STORAGE,
            value,
        };
    },
    getQueryVariableData: (locator) => {
        return {
            kind: 'QUERY_VARIABLE_REFERENCE',
            value: locator,
        };
    },
    createCustomObject: (label, fields, data) => {
        return createContentNode({
            kind: 'OBJECT',
            typeName: 'Object',
            isNullable: true,
            directives: [],
            state: {
                label,
                listDirection: 'column',
                textCase: 'all',
            },
            fields: fields.map(field => ({
                kind: 'FIELD',
                key: field.key,
                typeName: 'Field',
                directives: [],
                isNullable: true,
                args: [],
                state: {
                    label: field.label,
                },
                ofType: field.contentNodeRef,
            })),
        }, data ??
            Object.fromEntries(fields.map(field => [field.key, field.contentNodeRef])));
    },
};
//# sourceMappingURL=ManualContentHelpers.js.map